export default __webpack_public_path__ + "ef32372a0c5a1114521ba3f9f7f8f78c.png";